//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../axios-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * @return OK
 */
export function exchangeRatesGetExchangeRates(baseCurrency: string, toCurrencies: string[], config?: AxiosRequestConfig | undefined): Promise<Types.ListResultDtoOfExchangeRateDto> {
    let url_ = getBaseUrl() + "/api/exchange-rates?";
      if (baseCurrency === undefined || baseCurrency === null)
        throw new Error("The parameter 'baseCurrency' must be defined and cannot be null.");
      else
        url_ += "BaseCurrency=" + encodeURIComponent("" + baseCurrency) + "&";
      if (toCurrencies === undefined || toCurrencies === null)
        throw new Error("The parameter 'toCurrencies' must be defined and cannot be null.");
      else
        toCurrencies && toCurrencies.forEach(item => { url_ += "ToCurrencies=" + encodeURIComponent("" + item) + "&"; });
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigExchangeRatesGetExchangeRates,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigExchangeRatesGetExchangeRates?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processExchangeRatesGetExchangeRates(_response);
    });
}

function processExchangeRatesGetExchangeRates(response: AxiosResponse): Promise<Types.ListResultDtoOfExchangeRateDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.ListResultDtoOfExchangeRateDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListResultDtoOfExchangeRateDto>(null as any);
}
let _requestConfigExchangeRatesGetExchangeRates: Partial<AxiosRequestConfig> | null;
export function getExchangeRatesGetExchangeRatesRequestConfig() {
  return _requestConfigExchangeRatesGetExchangeRates;
}
export function setExchangeRatesGetExchangeRatesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigExchangeRatesGetExchangeRates = value;
}
export function patchExchangeRatesGetExchangeRatesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigExchangeRatesGetExchangeRates = patch(_requestConfigExchangeRatesGetExchangeRates ?? {});
}